{{#with props}}
<span class="{{obj_values_to_string styles}}">{{t locale-key}}</span>{{/with}}